module.exports = __webpack_public_path__ + "media/img/patterns/grid-vertical-btt-light-f098cd51ac4df567225a29363126b2d8.png";